'use client';

import { FC } from 'react';
import { shallow } from 'zustand/shallow';

import { useDocumentRequests } from '@/hooks/useDocumentRequests';
import { authStore } from '@/stores/authStore';
import { cartStore } from '@/stores/cartStore';
import { documentStore } from '@/stores/documentStore';
import { modalStore } from '@/stores/modalStore';

import { UserAvatar } from '../../UserAvatar/UserAvatar';
import { HeaderMenuAction } from './HeaderMenuAction';
import { HeaderMenuActionHamburgerMobile } from './HeaderMenuActionHamburgerMobile';

export const HeaderMenuActionHamburger: FC = () => {
  // Fetch document requests when user is authenticated
  useDocumentRequests();

  const { userData, userDataLoading } = authStore(
    ({ userData, userDataLoading }) => ({ userData, userDataLoading }),
    shallow,
  );
  const { cartActive } = cartStore((state) => {
    const cartActive = state.cartExpiry && !state.cartExpired;
    return { cartActive };
  }, shallow);
  const { hasPendingDocuments } = documentStore(
    (state) => ({
      hasPendingDocuments: state.hasPendingDocuments,
    }),
    shallow,
  );
  const { openModal } = modalStore(
    (state) => ({
      openModal: state.openModal,
    }),
    shallow,
  );

  // Show notification if there's an active cart OR pending documents
  const hasNotification = !!cartActive || hasPendingDocuments;

  return (
    <>
      <HeaderMenuActionHamburgerMobile
        onClick={() => openModal('mobileMenu')}
        userAvatarProps={{ userData, notification: hasNotification, loading: userDataLoading }}
      />
      <div className="relative hidden md:block">
        {userData ? (
          <HeaderMenuAction
            onClick={() => openModal('accountMenu')}
            title="Open my account menu"
            data-testid="header-menu-button"
          >
            <UserAvatar userData={userData} notification={hasNotification} loading={userDataLoading} />
          </HeaderMenuAction>
        ) : (
          <HeaderMenuAction
            href="/forms/-/auth/start"
            title="Login or create an account"
            data-testid="header-menu-button"
          >
            <UserAvatar userData={null} />
          </HeaderMenuAction>
        )}
      </div>
    </>
  );
};
